import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const QATab = ({ organisation }) => {
  const [questions, setQuestions] = useState([]);
  const [newQuestion, setNewQuestion] = useState({
    question_text: '',
    asker_name: '',
    asker_email: ''
  });

  const fetchQuestions = useCallback(async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/organisations/${organisation.id}/questions`);
      setQuestions(response.data);
    } catch (error) {
      console.error('Error fetching questions:', error);
    }
  }, [organisation.id]);

  useEffect(() => {
    fetchQuestions();
  }, [fetchQuestions]);

  const handleSubmitQuestion = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/organisations/${organisation.id}/questions`, newQuestion);
      setNewQuestion({ question_text: '', asker_name: '', asker_email: '' });
      fetchQuestions();
    } catch (error) {
      console.error('Error submitting question:', error);
    }
  };

  return (
    <div className="qa-tab">
      {/* Questions Column */}
      <div className="qa-tab__questions-column">
        {questions.length > 0 ? (
          questions.map((qa) => (
            <div key={qa.id} className="qa-tab__qa-card">
              {/* Left Column - Avatar */}
              <div className="qa-tab__qa-author-avatar">
                {(qa.asker_name || 'A')[0].toUpperCase()}
              </div>

              {/* Right Column - Q&A Content */}
              <div>
                <div className="qa-tab__qa-author-info">
                  <div className="qa-tab__qa-author-name">
                    <span className="qa-tab__qa-author">
                      {qa.asker_name || 'Anonymous'}
                    </span>
                  </div>
                  <span className="qa-tab__qa-date">
                    {new Date(qa.created_at).toLocaleDateString()}
                  </span>
                </div>
                <div className="qa-tab__qa-content">
                  <p className="qa-tab__question">{qa.question_text}</p>
                  {qa.answer && (
                    <div className="qa-tab__answer">
                      <h4 className="qa-tab__answer-label">Answer:</h4>
                      <p>{qa.answer}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="qa-tab__empty-state">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              fill="none" 
              viewBox="0 0 24 24" 
              strokeWidth={1.5} 
              stroke="currentColor" 
              className="qa-tab__empty-state-icon"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" 
              />
            </svg>
            <h3 className="qa-tab__empty-state-text">No Questions Yet</h3>
            <p className="qa-tab__empty-state-subtext">
              Be the first to ask a question
            </p>
          </div>
        )}
      </div>

      {/* Form Column */}
      <div className="qa-tab__form-column">
        <div className="qa-tab__form-sticky">
          <div className="qa-tab__form">
            <h3 className="qa-tab__form-title">Ask a Question</h3>
            <form onSubmit={handleSubmitQuestion} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Name</label>
                <input
                  type="text"
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                  value={newQuestion.asker_name}
                  onChange={(e) => setNewQuestion({...newQuestion, asker_name: e.target.value})}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Email</label>
                <input
                  type="email"
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                  value={newQuestion.asker_email}
                  onChange={(e) => setNewQuestion({...newQuestion, asker_email: e.target.value})}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Question</label>
                <textarea
                  required
                  rows={4}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                  value={newQuestion.question_text}
                  onChange={(e) => setNewQuestion({...newQuestion, question_text: e.target.value})}
                />
              </div>
              <button
                type="submit"
                className="btn btn--primary"
              >
                Submit Question
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QATab; 